module.exports = __webpack_public_path__ + "static/img/contact.76e5463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact.png
// module id = 550A
// module chunks = 0